var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "activityListView", staticClass: "waba-activity-list-view" },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading && _vm.activities.length === 0 } },
        [
          _vm.activities.length > 0
            ? [
                _vm._l(Object.keys(_vm.groups()), function (date) {
                  return _c("div", { key: date, staticClass: "date-group" }, [
                    _c("div", { staticClass: "date-header" }, [
                      _c("div", { staticClass: "date-badge" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("event"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$moment(date, "YYYY-MM-DD").format("LL"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "date-line" }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "activity-cards" },
                      _vm._l(_vm.groups()[date], function (activity) {
                        return _c("WabaActivityCard", {
                          key: activity._id,
                          attrs: { activity: activity },
                        })
                      }),
                      1
                    ),
                  ])
                }),
                _vm._v(" "),
                _c("div", { staticClass: "load-more-container" }, [
                  _c(
                    "button",
                    {
                      staticClass: "load-more-btn",
                      class: { disabled: !_vm.hasMore || _vm.loading },
                      attrs: { disabled: !_vm.hasMore || _vm.loading },
                      on: { click: _vm.handleLoadMore },
                    },
                    [
                      _vm.loading
                        ? _c("a-spin", { attrs: { size: "small" } })
                        : [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.hasMore ? "expand_more" : "check_circle"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.hasMore
                                    ? "Daha Fazla Yükle"
                                    : "Tüm Aktiviteler Yüklendi"
                                )
                              ),
                            ]),
                          ],
                    ],
                    2
                  ),
                ]),
              ]
            : !_vm.loading
            ? _c("div", { staticClass: "empty-activities" }, [
                _c("div", { staticClass: "empty-icon" }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("history"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "empty-title" }, [
                  _vm._v("Henüz Aktivite Yok"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "empty-desc" }, [
                  _vm._v(
                    "\n                Bu kanal için henüz bir webhook aktivitesi kaydedilmemiş.\n                Meta'dan webhook alındığında aktiviteler burada görüntülenecektir.\n            "
                  ),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }